import { render, staticRenderFns } from "./ExternalWordcloud.vue?vue&type=template&id=5ccf9fc1&scoped=true"
import script from "./ExternalWordcloud.vue?vue&type=script&lang=js"
export * from "./ExternalWordcloud.vue?vue&type=script&lang=js"
import style0 from "./ExternalWordcloud.vue?vue&type=style&index=0&id=5ccf9fc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccf9fc1",
  null
  
)

export default component.exports